import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import Navbar from 'src/components/navbar';
import { userHasPermission } from 'src/utils/context';
import config from 'config/config';

const getNavItems = ({ community, currentUser, isAdmin }) => {
  const aboutItem = {
    link: `/community/communityAbout?slug=${community.slug}`,
    as: `/${community.slug}/about`,
    isCrawlable: true,
    id: 'about',
    content: i18n.t('About'),
  };
  return [
    {
      link: `/community/communityHome?slug=${community.slug}`,
      as: `/${community.slug}`,
      isCrawlable: true,
      id: 'home',
      content: i18n.t('Home'),
    },
    !currentUser && aboutItem,
    {
      link: `/community/communityPosts?slug=${community.slug}`,
      as: `/${community.slug}/posts`,
      isCrawlable: true,
      id: 'posts',
      content: i18n.t('Posts'),
      isPostsLinkInCommunityHeader: true,
    },
    config.discover.communities.includes(community.slug) && {
      link: `/${community.slug}/discover`,
      isCrawlable: false,
      id: 'discover',
      content: i18n.t('Discover'),
    },
    !community.isArchived && {
      link: `/community/communityMembers?slug=${community.slug}`,
      as: `/${community.slug}/members`,
      isCrawlable: false,
      id: 'members',
      content: i18n.t('Members'),
    },
    currentUser && aboutItem,
    isAdmin && {
      link: `/${community.slug}/settings`,
      id: 'settings',
      content: (
        <span>
          <span className="icon icon-cog" /> {i18n.t('Admin')}
        </span>
      ),
    },
  ].filter(x => !!x);
};

const CommunityHeaderNavBar = ({ community, currentUser, currentPage }) => {
  if (!community) return null;
  const isAdmin = userHasPermission(currentUser, 'ViewAdminMenu');

  return (
    <div className="community-header__navbar" id="community-header__navbar">
      <Navbar
        isCompact={true}
        items={getNavItems({ community, currentUser, isAdmin })}
        selectedPage={currentPage}
      />
    </div>
  );
};

CommunityHeaderNavBar.propTypes = {
  community: PropTypes.object,
  currentPage: PropTypes.string,
  currentUser: PropTypes.object,
};

CommunityHeaderNavBar.defaultProps = {
  currentUser: null,
  currentPage: '',
};

export default CommunityHeaderNavBar;
